import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
const badges = ['150 Ready-to-Teach Lessons', '5 Complete Volumes', '5 Free Bonuses', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-12 px-4 overflow-hidden bg-cream" data-id="element-144" data-mp="4njqkdok21ck">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-145" data-mp="1285wpmvfbqls">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-146" data-mp="xbflbcukdj6p">
          <p className="inline-block px-3 py-1 rounded-full border border-terracotta/30 bg-sand text-terracotta-deep font-semibold text-[10px] sm:text-sm tracking-[0.18em] uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-147" data-mp="3d2bj5ngruvuh">
            Drawing Teacher Ready
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-charcoal" data-id="element-148" data-mp="3o85cdefo0765">
            Solve an entire year of{' '}
            <span className="text-terracotta" data-id="element-149" data-mp="39cpfl1np9x62">drawing classes</span> in just 5
            minutes.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-xl md:max-w-3xl mb-4 sm:mb-6" data-id="element-150" data-mp="30hrf99i83i4p">
          <img src="https://cdn.magicpatterns.com/uploads/vpgFdEsB3j2qSmsyLwNDYA/Diseno_sin_titulo_(66).png" alt="Drawing Teacher Ready — complete teaching library, class finder and five bonus guides" className="relative z-10 w-full h-auto" data-id="element-151" data-mp="2hk86m6zog1it" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-152" data-mp="najihr3gojgl">
          <p className="text-sm sm:text-lg md:text-xl text-charcoal-soft leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-153" data-mp="1ayjh1d70le5q">
            Complete teaching library with class finder and five professional
            guides—ready to open, teach, and inspire today.
          </p>

          <ul className="flex flex-wrap justify-center gap-2 mb-6 sm:mb-7" data-id="element-154" data-mp="x0l8iofdkby5">
            {badges.map(badge => <li key={badge} className="bg-terracotta-deep text-paper text-[10px] sm:text-xs font-semibold uppercase tracking-wider rounded-full px-3 py-1.5" data-id="element-155" data-mp="3lquftrppid6n">
                {badge}
              </li>)}
          </ul>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-156" data-mp="21bfsnhwi11qr">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-157" data-mp="269hgsh8s7r93">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal-muted" data-id="element-158" data-mp="2kxc9vyqpbxmp">
            <div className="flex items-center gap-1.5" data-id="element-159" data-mp="2oye7yc8vu3n3">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-160" data-mp="2tyiqe7tcp8fy" />
              <span data-id="element-161" data-mp="uou3xbyyw0ch">6 complete volumes</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-162" data-mp="zmc2q9j9sz6r">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-163" data-mp="4b46ts95i2ix" />
              <span data-id="element-164" data-mp="3vh5lsbw8lg9u">5 strategic bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-165" data-mp="ea3g9d1qq26z">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-166" data-mp="e7ha9huhzuqv" />
              <span data-id="element-167" data-mp="3hphb8d1myzuz">Instant access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}